import { Typography } from '@mui/material';
import CasLabel from '../CasLabel/CasLabel';
import CasLink from '../CasLink/CasLink';

interface ICasDisplayField {
  label: string | React.ReactElement;
  value: React.ReactNode;
  className?: string;
  horizontal?: boolean;
  fullWidth?: boolean;
  onClick?: VoidFunction | null;
}

export default function CasDisplayField({
  label,
  value,
  className,
  horizontal = false,
  fullWidth,
  onClick = null,
}: ICasDisplayField) {
  const renderLabel = onClick ? <CasLink onClick={onClick}>{label}</CasLink> : label;

  const renderValue = () => {
    if (Array.isArray(value)) {
      return value.map((v, index) => (
        <Typography key={index} variant="body2" component="div" className="cas-display-value">
          {v}
        </Typography>
      ));
    }

    return (
      <Typography variant="body2" component="div" className="cas-display-value">
        {value ?? ''}
      </Typography>
    );
  };

  return (
    <CasLabel
      label={renderLabel}
      className={`cas-display-field ${  horizontal ? 'cas-horizontal-field ' : ''}${className}`}
      sx={fullWidth && { flex: 1 }}
    >
      {renderValue()}
    </CasLabel>
  );
}
